import { createFileRoute } from "@tanstack/react-router";
import { InvitePage } from "./-invite/InvitePage";

/** A sign-up invitation code from the waitlist email: `/invite/ABCD-EFGH`. */
export const Route = createFileRoute("/invite/$code")({
  staticData: { title: "Your invitation" },
  component: InvitePage,
});
